<script setup>
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['change']);

const { t } = useI18n();

const modelValue = defineModel({
  type: Boolean,
  default: false,
});

const updateValue = () => {
  modelValue.value = !modelValue.value;
  emit('change', !modelValue.value);
};
</script>

<template>
  <button
    type="button"
    class="group relative h-4 rounded-full w-7 flex-shrink-0 select-none focus:outline-none focus:ring-1 focus:ring-n-brand focus:ring-offset-n-slate-2 focus:ring-offset-2 transition-colors duration-200"
    :class="modelValue ? 'bg-n-brand' : 'bg-n-slate-6'"
    role="switch"
    :aria-checked="modelValue"
    @click="updateValue"
  >
    <span class="sr-only">{{ t('SWITCH.TOGGLE') }}</span>
    <span
      class="absolute top-1/2 ltr:left-0.5 rtl:right-0.5 -translate-y-1/2 transition-transform duration-[350ms] ease-[var(--mov-curva-pulo)]"
      :class="
        modelValue
          ? 'ltr:translate-x-3 rtl:-translate-x-3 group-active:ltr:translate-x-[6px] rtl:group-active:-translate-x-[6px]'
          : 'ltr:translate-x-0 rtl:translate-x-0'
      "
    >
      <span
        class="block h-3 w-3 rounded-full bg-n-background shadow-md transition-[width] duration-[180ms] group-active:w-[18px]"
      />
    </span>
  </button>
</template>

<style scoped>
/* O interruptor desenha 16x28 — a medida certa para ele não virar um botão
   gordo ao lado de um rótulo. No telefone o ALVO cresce por fora, no
   `::after`, sem mexer no desenho: é a mesma solução da ação de linha e da
   caixa de escolha (medido na ficha do cliente em 14/09/2026: 16px). */
@media (max-width: 639px) {
  button.group {
    position: relative;
  }

  button.group::after {
    content: '';
    position: absolute;
    inset: -14px;
  }
}
</style>
